module.exports = __webpack_public_path__ + "static/media/marquee.6b89e0fe.jpg";